import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

// styled-components v6 introduced breaking changes with large impacts on our codebase.
//  We can temporarily disable the features here and slowly work towards remediation without
//  blocking the upgrade.
//  For remediation, we need to update all transient props to be prefixed with $
//  https://styled-components.com/docs/faqs#shouldforwardprop-is-no-longer-provided-by-default
function StyleSheetManagerProvider({ children }) {
    return (
        <StyleSheetManager
            shouldForwardProp={shouldForwardProp}
            // styled-components v6 default this to false, we have vendor prefixes in some styles
            //  and can look into removing this in the future if vendor prefixes are not needed
            enableVendorPrefixes={true}
        >
            {children}
        </StyleSheetManager>
    );
}

StyleSheetManagerProvider.propTypes = {
    children: PropTypes.node.isRequired,
};


// styled-components v6 requires styled props to be prefixed with $
//  This function implements the default behaviour from styled-components v5
//  so we don't have to block the upgrade.
//  Source: https://styled-components.com/docs/faqs#shouldforwardprop-is-no-longer-provided-by-default
function shouldForwardProp(propName, target) {
    if (typeof target === 'string') {
        // For HTML elements, forward the prop if it is a valid HTML attribute
        return isPropValid(propName);
    }
    // For other elements, forward all props
    return true;
}

export default StyleSheetManagerProvider;
